import React, { createContext, useContext, useMemo, useState } from "react";

export const BulkDataContext = createContext(null);

const BulkDataProvider = (props) => {
  // const [bulkData, setBulkData] = useState(JSON.parse(localStorage.getItem("bulk")));
  const [bulkData, setBulkData] = useState(null);

  const bulkDataValue = useMemo(() => ({ bulkData, setBulkData }), [bulkData]);

  return <BulkDataContext.Provider value={{ bulkDataValue }} {...props} />;
};

export const useBulkDataContext = () => useContext(BulkDataContext);
export default BulkDataProvider;
